import { useState } from 'react';
import { Alert } from 'react-bootstrap';
import { DISABLE_ORG_ALERT_BANNER } from '../../../../shared/featureFlags/flagNames';
import { window } from '../../../globals';
import { isFeatureEnabled } from '../../../helpers/features';

/**
 * OrgAlertBanner.tsx
 *
 *
 * This component is used to display a bright red warning to let the FOSSA team
 * know that they are not in their own account/organization but instead in
 * the customers' account space/organization.
 *
 * This is only displayed when a FOSSA team member needs to jump into a customer organization to assist the customer.
 */
const OrgAlertBanner = () => {
  // declare show state
  const [isShowing, setShow] = useState(true);

  const isFossaOrg = window.user?.organizationId === 1;

  const shouldShowAlert = !!(
    isShowing &&
    !window.on_prem &&
    window.user?.super &&
    !isFossaOrg &&
    !isFeatureEnabled(DISABLE_ORG_ALERT_BANNER)
  );

  return shouldShowAlert && (
    <Alert bsStyle="neworg" onDismiss={() => setShow(false)}>
      Warning: You are outside of the FOSSA organization.
    </Alert>
  );
};

export default OrgAlertBanner;
